import { Link } from 'react-router-dom'

export function NotFound() {
  return (
    <div className="text-center">
      <h1 className="text-4xl">Page Not Found</h1>
      <p className="mt-4 text-gray-600">
        Awkward... wanna{' '}
        <Link to="/" className="helix-text-brand">
          go home
        </Link>
        ?
      </p>
      <svg
        className="m-auto mt-8 max-w-[500px] p-5"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 907 473.85">
        <title>Cloud CMA</title>
        <path
          fill="none"
          d="M314.31,332.22a6.9,6.9,0,0,0,11.73-6c0-.06,0-.11,0-.16l-.81-6.27a17.53,17.53,0,0,1-14.73,8.09c-.32,0-.65,0-1,0l4.45,4.15A2,2,0,0,1,314.31,332.22Z"
        />
        <path
          fill="none"
          d="M330,325.77a6.89,6.89,0,0,0,12.33,3.65l4-6.27a17.29,17.29,0,0,1-5.26.82,17.65,17.65,0,0,1-3.8-.42,17.4,17.4,0,0,1-8.07-4.2l.82,6.39Z"
        />
        <path fill="none" d="M215.5,450.75v-4.69a10.44,10.44,0,0,1-2-.39Z" />
        <path
          fill="none"
          d="M210.45,437.66l0,.07a6.38,6.38,0,0,0,5,4.28v-7.83a16.56,16.56,0,0,1-7.12-1.89Z"
        />
        <path
          fill="none"
          d="M309.7,308.83a21.63,21.63,0,0,0,3.1-1.95H288.65c-.54,0-1.07,0-1.6-.08A21.15,21.15,0,0,0,309.7,308.83Z"
        />
        <path
          fill="none"
          d="M327.86,308.92l.06.44a13.39,13.39,0,0,0,23.88,5.16l4.74-7.49a25.08,25.08,0,0,1-10.48,2.3,25.5,25.5,0,0,1-10.9-2.45h-7.56l.11.83C327.76,308.12,327.82,308.52,327.86,308.92Z"
        />
        <path
          fill="none"
          d="M204.91,423.28a12.48,12.48,0,0,0,10.59,6.91V419.82a24,24,0,0,1-13.56-4.25Z"
        />
        <path
          fill="none"
          d="M311.53,312.39a25.33,25.33,0,0,1-11.6,2.83,25,25,0,0,1-4.34-.39l5.18,4.82.16.14a13.4,13.4,0,0,0,23-10.12c-.1-.55-.18-1.11-.22-1.67a2,2,0,0,1,0-.23l-.11-.88H318.7A25.41,25.41,0,0,1,311.53,312.39Z"
        />
        <path
          fill="none"
          d="M184.32,385.4v12.13A29.49,29.49,0,0,0,184.32,385.4Z"
        />
        <path
          fill="none"
          d="M194.1,395.23l3.87,10a19.92,19.92,0,0,0,17.53,10.54V403.27h-.17A33,33,0,0,1,194.1,395.23Z"
        />
        <path
          fill="none"
          d="M483.34,329.71h37.27c-1.94-19.68-6.92-22.72-7-22.75l.11.05,0-.12h-6.27A81.19,81.19,0,0,1,483.34,329.71Z"
        />
        <path
          fill="none"
          d="M202.94,458.19a10.52,10.52,0,0,1-1,3.08l9.36-1.74L203,454.89A10.51,10.51,0,0,1,202.94,458.19Z"
        />
        <path
          fill="none"
          d="M187.79,463.9l6.66-1.24a6.42,6.42,0,0,0,1.06-11.92h0l-5.08-2.83a16.65,16.65,0,0,1-2.63,16Z"
        />
        <path
          fill="none"
          d="M199.8,440.61a16.59,16.59,0,0,1-7.54,3.74l5,2.79.12.06a6.43,6.43,0,0,0,9.27-8.06,2,2,0,0,1-.15-.57l-1.92-5A16.59,16.59,0,0,1,199.8,440.61Z"
        />
        <path
          fill="none"
          d="M174,466.47l4-.74a12.57,12.57,0,0,0,3.82-22.62l-.41-.23-1.08-.6-5.57-3.11A24,24,0,0,1,177,453.91a19.75,19.75,0,0,1-.42,2v2.63A13.74,13.74,0,0,1,174,466.47Z"
        />
        <path
          fill="none"
          d="M368.42,321.94a21.2,21.2,0,0,0,12.32,7.77h8.88l.77-.19,5.57-1.8a81.22,81.22,0,0,1-21.08-20.83H364A21.18,21.18,0,0,0,368.42,321.94Z"
        />
        <path
          fill="none"
          d="M166.45,429.91a20,20,0,0,0,27.27-24.24c-.33-.74-.64-1.49-.9-2.27a2,2,0,0,1-.09-.6l-3.8-9.86a33.56,33.56,0,0,1-11.59,23.9,34,34,0,0,1-9.82,6,15.18,15.18,0,0,1-2.27,6.38C165.66,429.41,166.05,429.66,166.45,429.91Z"
        />
        <path
          fill="none"
          d="M207.62,449.6a10.5,10.5,0,0,1-2.8,1.74l8.42,4.69-3.47-9A10.51,10.51,0,0,1,207.62,449.6Z"
        />
        <path fill="none" d="M686,420.18h0v0Z" />
        <path fill="none" d="M669.68,420.18h.06l0-.07Z" />
        <path
          fill="none"
          d="M677.89,419.54a12,12,0,0,1-4.44-.85l.54,1.49h7.77l.53-1.48A12,12,0,0,1,677.89,419.54Z"
        />
        <path
          fill="none"
          d="M365.26,324.39a25.22,25.22,0,0,1-5.33-15.24L356.21,315s0,.08-.06.13c-.25.45-.53.88-.82,1.3a13.29,13.29,0,0,0,0,13.26h15.48A25.49,25.49,0,0,1,365.26,324.39Z"
        />
        <path
          fill="none"
          d="M691.73,392.53c.18-.59.38-1.18.62-1.76a2,2,0,0,1,.12-.22l2.91-8.05a28.05,28.05,0,0,1-28.48,3.9v10.41a15.14,15.14,0,0,0,24.83-4.29Z"
        />
        <path
          fill="none"
          d="M160.15,336.71l1.82-.25.38,0a12.15,12.15,0,0,0,10.57-12V309.05a6.51,6.51,0,0,0-6.5-6.5H162a21.67,21.67,0,0,0-4.39.58,4.94,4.94,0,0,0-3.32,2.77c-.36,10.34-1.4,21-2.65,30.55C154,337.58,156.87,337.18,160.15,336.71Z"
        />
        <path
          fill="none"
          d="M699.07,384l-3,8.28-.48,1.33-.17.47a15.15,15.15,0,0,0,13.65,19.1l-1.62-14.42A27.75,27.75,0,0,1,699.07,384Z"
        />
        <path
          fill="none"
          d="M666.89,412.55v3.88A7.83,7.83,0,0,0,666.89,412.55Z"
        />
        <path
          fill="none"
          d="M697.82,412.84a19.13,19.13,0,0,1-6-8.74l-2.63,7.29v0a7.83,7.83,0,0,0,1.88,8.74h11.2l5.26-3.09A19.11,19.11,0,0,1,697.82,412.84Z"
        />
        <path
          fill="none"
          d="M324.23,337.09a11,11,0,0,1-3.54,1.11l7.21,6.71h.56l-1.29-10A11,11,0,0,1,324.23,337.09Z"
        />
        <path
          fill="none"
          d="M331.15,334.47l1,8a15.64,15.64,0,0,1,2.93-6.53c-.18,0-.36,0-.55-.09A11,11,0,0,1,331.15,334.47Z"
        />
        <path
          fill="none"
          d="M317.15,344.81l-.05.11H322l-4-3.74A11,11,0,0,1,317.15,344.81Z"
        />
        <path
          fill="none"
          d="M346.89,329.75c.24,0,.49,0,.73,0h3.3a17.27,17.27,0,0,1-1.2-4.45Z"
        />
        <path
          fill="none"
          d="M301.9,338.28a13.33,13.33,0,0,0-3.66-15.5,2,2,0,0,1-.2-.21l-5.12-4.77a25.41,25.41,0,0,1-10.4,27.11h13.24A13.35,13.35,0,0,0,301.9,338.28Z"
        />
        <path
          fill="none"
          d="M685.44,410c0-.06,0-.11.07-.17l2.6-7.19a19.27,19.27,0,0,1-20.46,0l2.51,7a2,2,0,0,1,.19.41,7.9,7.9,0,0,0,15.1,0Z"
        />
        <path
          fill="none"
          d="M311.59,335.25a2,2,0,0,1-.33-.37l-4.41-4.1a17.49,17.49,0,0,1-4.57,14.14h10.15a6.93,6.93,0,0,0,1-1.68A6.86,6.86,0,0,0,311.59,335.25Z"
        />
        <path
          fill="none"
          d="M706.68,391.84l-1.16-10.34h-.39a2,2,0,0,1-2-2v-6.63A23.69,23.69,0,0,0,706.68,391.84Z"
        />
        <path
          fill="none"
          d="M182.2,438.7c.48.24.95.51,1.4.79A12.58,12.58,0,0,0,200.43,423a2,2,0,0,1-.15-.61l-2.17-5.63a24.18,24.18,0,0,1-21.54,18.84l5.45,3Z"
        />
        <path fill="#c4c8d0" d="M389.62,329.71h9.43q-1.57-1-3.1-2l-5.57,1.8Z" />
        <path fill="#c4c8d0" d="M258.36,344.62a2.06,2.06,0,0,0-1.14.3h6.38Z" />
        <path
          fill="#c4c8d0"
          d="M291.61,333.88a25.21,25.21,0,0,0,1.3-16.08l5.12,4.77a2,2,0,0,0,.2.21,13.41,13.41,0,0,1-2.49,22.13h6.53a17.49,17.49,0,0,0,4.57-14.14l4.41,4.1a2,2,0,0,0,.33.37,6.86,6.86,0,0,1,1.88,8,6.93,6.93,0,0,1-1,1.68h4.67l.05-.11a11,11,0,0,0,.86-3.63l4,3.74h5.87l-7.21-6.71a10.93,10.93,0,0,0,6.48-3.31l1.29,10h3.46a15.74,15.74,0,0,1,.26-2.44l-1-8a11,11,0,0,0,3.41,1.38c.18,0,.36.06.55.09a15.8,15.8,0,0,1,6.24-4.93l.38-.16a15.62,15.62,0,0,1,4.9-1.11h.26l2.84-4.48a17.27,17.27,0,0,0,1.2,4.45h4.46a13.29,13.29,0,0,1,0-13.26c.29-.42.57-.85.82-1.3,0,0,0-.08.06-.13l3.71-5.86a25.22,25.22,0,0,0,5.33,15.24,25.49,25.49,0,0,0,5.61,5.32h9.87A21.33,21.33,0,0,1,364,306.88H335.16a25.5,25.5,0,0,0,10.9,2.45,25.08,25.08,0,0,0,10.48-2.3l-4.74,7.49a13.39,13.39,0,0,1-23.88-5.16l-.06-.44c0-.4-.09-.8-.15-1.2l-.11-.83h-4l.11.88a2,2,0,0,0,0,.23c0,.57.13,1.12.22,1.67a13.4,13.4,0,0,1-23,10.12l-.16-.14-5.18-4.82a25,25,0,0,0,4.34.39,25.45,25.45,0,0,0,18.77-8.33h-5.9a21.63,21.63,0,0,1-3.1,1.95,21.15,21.15,0,0,1-22.65-2h-.13a18.11,18.11,0,0,1-5.37-1.35l-.09,0a18.3,18.3,0,0,1-5.33-3.52,2,2,0,0,0,.5.77l5.15,4.8.09.11a25.84,25.84,0,0,0,2,1.87,21.26,21.26,0,0,1-12,35.49h10.6A25.25,25.25,0,0,0,291.61,333.88Zm45.66-10.32a17.65,17.65,0,0,0,3.8.42,17.29,17.29,0,0,0,5.26-.82l-4,6.27A6.89,6.89,0,0,1,330,325.77v0l-.82-6.39A17.4,17.4,0,0,0,337.27,323.57Zm-26.78,4.28a17.53,17.53,0,0,0,14.73-8.09L326,326c0,.05,0,.11,0,.16a6.9,6.9,0,0,1-11.73,6,2,2,0,0,0-.34-.28l-4.45-4.15C309.84,327.82,310.17,327.85,310.49,327.85Z"
        />
        <path
          fill="#c4c8d0"
          d="M705.12,359.28h2.1a2,2,0,0,0-3.58.35l-.23.64A2,2,0,0,1,705.12,359.28Z"
        />
        <path
          fill="#c4c8d0"
          d="M677.89,388.64a27.8,27.8,0,0,0,17.48-6.14l-2.91,8.05a2,2,0,0,0-.12.22c-.24.58-.44,1.17-.62,1.76a15.14,15.14,0,0,1-24.83,4.29v15.73a7.83,7.83,0,0,1,0,3.88v3.75h2.78l0-.07,0,.07H674l-.54-1.49a12,12,0,0,0,8.84,0l-.53,1.48H686v0h5a7.83,7.83,0,0,1-1.88-8.74v0l2.63-7.29a19.23,19.23,0,0,0,15.69,13l-5.26,3.09h7.61c0-.06,0-.13,0-.19l-.31-2.74-.14-1.26-.31-2.75a15.15,15.15,0,0,1-13.65-19.1l.17-.47.48-1.33,3-8.28a27.75,27.75,0,0,0,8.39,14.76l-.78-7a23.69,23.69,0,0,1-3.55-19V361.28a2,2,0,0,1,0-.32l-2.25,6.23a2,2,0,0,0-.28.46,28.34,28.34,0,0,0-1.08,3.17A23.94,23.94,0,0,1,666.89,382v4.42A28,28,0,0,0,677.89,388.64Zm0,26.9a7.85,7.85,0,0,1-7.55-5.58,2,2,0,0,0-.19-.41l-2.51-7a19.27,19.27,0,0,0,20.46,0l-2.6,7.19c0,.06-.05.11-.07.17A7.85,7.85,0,0,1,677.89,415.54Z"
        />
        <path
          fill="#c4c8d0"
          d="M216.82,462.44h0a15,15,0,0,1-.67-1.78c-.08-.27-.15-.55-.21-.83s-.16-.74-.23-1.12l0-.25c-.05-.37-.1-.75-.12-1.13s-.05-.67-.05-1c0,0,0,0,0,0v-5.53l-2-5.08a10.44,10.44,0,0,0,2,.39v-4a6.38,6.38,0,0,1-5-4.28l0-.07-2.07-5.37a16.56,16.56,0,0,0,7.12,1.89v-4a12.48,12.48,0,0,1-10.59-6.91l-3-7.71a24,24,0,0,0,13.56,4.25v-4A19.92,19.92,0,0,1,198,405.27l-3.87-10a33,33,0,0,0,21.22,8h.17v-4a29.38,29.38,0,0,1-26.57-17.43l-2.52-6.53a2,2,0,0,0-3-.94h.89a2,2,0,0,1,0,4V381h0v4.41a29.49,29.49,0,0,1,0,12.13V401a2,2,0,1,1,0,4h-2.66a29.81,29.81,0,0,1-14.26,13.53,14.17,14.17,0,0,1,.11,4.31,34,34,0,0,0,9.82-6,33.56,33.56,0,0,0,11.59-23.9l3.8,9.86a2,2,0,0,0,.09.6c.26.78.57,1.54.9,2.27a20,20,0,0,1-27.27,24.24c-.39-.25-.79-.5-1.19-.74l-.05.09,0,0a14.61,14.61,0,0,1-2.55,3l-.08.07,0,0q.79.46,1.6.85l.71.4a19.92,19.92,0,0,1,5.58,6,13.82,13.82,0,0,1,6.15,11.49v4.78a19.75,19.75,0,0,0,.42-2,24,24,0,0,0-2.23-14.75l5.57,3.11,1.08.6.41.23A12.57,12.57,0,0,1,178,465.73l-4,.74a13.92,13.92,0,0,1-2.22,2.45,13.75,13.75,0,0,1-8,3.35,2,2,0,0,0,.44.05,2,2,0,0,0,.37,0L176.88,470H177a16.91,16.91,0,0,0,1.79-.35l15-2.8h.21a10.62,10.62,0,0,0,1.29-.26l21.54-4-.05-.11Zm-14.9-1.17a10.53,10.53,0,0,0,1-6.38l8.32,4.64Zm4.58-22.71a2,2,0,0,0,.15.57,6.43,6.43,0,0,1-9.27,8.06l-.12-.06-5-2.79a16.64,16.64,0,0,0,12.32-10.78Zm-1.69,12.78a10.49,10.49,0,0,0,5-4.31l3.47,9Zm-14.46-21.59a24,24,0,0,0,7.74-13l2.17,5.63a2,2,0,0,0,.15.61,12.58,12.58,0,0,1-16.82,16.5c-.45-.28-.91-.55-1.4-.79l-.2-.07-5.45-3A24,24,0,0,0,190.36,429.75Zm.05,18.14,5.08,2.83h0a6.42,6.42,0,0,1-1.06,11.92l-6.66,1.24a16.65,16.65,0,0,0,2.63-16Z"
        />
        <path
          fill="#fafafa"
          d="M320.52,295.45H604a5.92,5.92,0,0,0,2.47-.54,14.15,14.15,0,0,0,1.48-6.28V151l-19.88-1.92,5.48-56.71,1.2.12.88-9.14a2,2,0,0,1,2.18-1.8l10.13,1V20.13A14.27,14.27,0,0,0,593.74,5.88H288.65A14.27,14.27,0,0,0,274.4,20.13V165.92l20.72-.41a2.05,2.05,0,0,1,1.43.56,2,2,0,0,1,.61,1.4l.63,32.16a64.47,64.47,0,0,1-2.28,19.12l.29,14.85L274.4,234v54.61a14.15,14.15,0,0,0,1.48,6.28,5.92,5.92,0,0,0,2.47.54Zm.73-6.46,0,0h0a6.3,6.3,0,1,1,2.65-5.13c0,.07,0,.13,0,.2s0,.12,0,.18A6.29,6.29,0,0,1,321.25,289Zm90.8,1.21h-4V277.57h4Zm12.46,0h-4V277.57h4Zm12.46,0h-4V277.57h4Zm12.46,0h-4V277.57h4Zm12.46,0h-4V277.57h4Zm12.46,0h-4V277.57h4Zm89.65,0H551.37V277.57H564Zm-262.14-236a20.84,20.84,0,0,1,20.81-20.81H559.72a20.84,20.84,0,0,1,20.81,20.81v191A20.84,20.84,0,0,1,559.72,266H322.67a20.83,20.83,0,0,1-20.81-20.81Z"
        />
        <path
          fill="#dedfe4"
          d="M276.2,295.55c.2.35.4.69.62,1l0,0c.23.34.48.66.73,1l.22.27q.31.37.65.71l.2.21q.43.42.89.81l.22.17q.38.3.78.58l.29.2c.33.22.68.43,1,.63h0c.36.2.73.37,1.11.53l.32.13q.46.19.93.34l.27.09q.59.18,1.21.31l.28.05q.5.09,1,.15l.36,0c.43,0,.86.07,1.3.07H593.74c.44,0,.87,0,1.3-.07l.36,0q.51-.06,1-.15l.28-.05q.61-.13,1.21-.31l.27-.09q.47-.15.93-.34l.32-.13c.38-.16.75-.34,1.11-.53h0c.35-.19.69-.4,1-.62l.29-.2q.4-.28.77-.58l.22-.18q.46-.39.89-.81l.2-.21q.34-.34.65-.71l.23-.27c.26-.32.5-.64.73-1l0,0c.22-.33.43-.67.62-1l.17-.31.18-.34h0a5.92,5.92,0,0,1-2.47.54H278.34a5.92,5.92,0,0,1-2.47-.54h0l.18.34Z"
        />
        <path fill="#11163d" d="M272.4,289.5a6,6,0,0,0,1.81,4.28l-1.76-4.16Z" />
        <path
          fill="#11163d"
          d="M610,289.5l0,.12-1.76,4.16A6,6,0,0,0,610,289.5Z"
        />
        <path
          fill="#11163d"
          d="M514.58,304.88H600a5.94,5.94,0,0,0,5.93-5.57c0-.12,0-.25,0-.37l2.19-5.16a6,6,0,0,1-1.64,1.13l-.18.34-.17.31c-.19.35-.4.69-.62,1l0,0c-.23.34-.47.66-.73,1l-.23.27q-.31.37-.65.71l-.2.21q-.43.42-.89.81l-.22.18q-.38.3-.77.58l-.29.2c-.33.22-.67.43-1,.62h0c-.36.2-.73.37-1.11.53l-.32.13q-.46.19-.93.34l-.27.09q-.59.18-1.21.31l-.28.05q-.5.09-1,.15l-.36,0c-.43,0-.86.07-1.3.07H288.65c-.44,0-.87,0-1.3-.07l-.36,0q-.51-.06-1-.15l-.28-.05q-.61-.13-1.21-.31l-.27-.09q-.47-.15-.93-.34l-.32-.13c-.38-.16-.75-.34-1.11-.53h0c-.35-.19-.69-.41-1-.63l-.29-.2q-.4-.28-.78-.58l-.22-.17q-.46-.39-.89-.81l-.2-.21q-.34-.35-.65-.71l-.22-.27c-.26-.32-.5-.64-.73-1l0,0c-.22-.33-.43-.67-.62-1l-.16-.31-.18-.34a6,6,0,0,1-1.64-1.13l2.19,5.16c0,.13,0,.25,0,.37s0,.39.07.58a5.94,5.94,0,0,0,5.33,5h.09l.44,0H514.58Z"
        />
        <path
          fill="#fff"
          d="M522,261.82H322.69a18.78,18.78,0,0,1-6.81-1.27,16.7,16.7,0,0,0,6.78,1.44H559.72a16.7,16.7,0,0,0,6.78-1.44,18.79,18.79,0,0,1-6.81,1.27Z"
        />
        <path
          fill="#fff"
          d="M325,254.48H557.41A18.48,18.48,0,0,0,575.89,236V49.59a16.78,16.78,0,0,0-3.74-6.72L572,43l-12.05,8.28a2,2,0,0,1-1.67,1.14l-2.51,1.72c-.24,1.52-.68,4-1.32,6.93l12,10.84a2,2,0,1,1-2.68,3l-10.39-9.39c-1.58,5.88-3.89,12-6.95,13.77a2,2,0,1,1-2-3.44c3.09-1.84,6.29-14.64,7.57-23.15a2,2,0,0,1,.07-.31l-12.16-2.26-6.73,12.8A2,2,0,1,1,529.58,61L537,46.94a2,2,0,0,1,1.78-1.07,2.05,2.05,0,0,1,.36,0l13.52,2.51H557l12-8.25a16.71,16.71,0,0,0-9.31-2.82H322.67A16.83,16.83,0,0,0,306.5,49.59V236A18.48,18.48,0,0,0,325,254.48Zm68.61-80.81,47-81.44a2.49,2.49,0,0,1,4.32,0l47,81.44a2.49,2.49,0,0,1-2.16,3.74h-94a2.49,2.49,0,0,1-2.16-3.74ZM497.68,203h38.05a2,2,0,0,1,2,2v20.3a2,2,0,0,1-2,2H352.12a2,2,0,0,1-2-2V205a2,2,0,0,1,2-2H497.68ZM367.29,50.12A6.31,6.31,0,1,1,361,56.43,6.31,6.31,0,0,1,367.29,50.12Zm-20.37,0a6.31,6.31,0,1,1-6.31,6.31A6.31,6.31,0,0,1,346.92,50.12Zm-19.91,0a6.31,6.31,0,1,1-6.31,6.31A6.31,6.31,0,0,1,327,50.12Z"
        />
        <polygon
          fill="#fff"
          points="475.83 223.34 512.78 223.34 533.74 223.34 533.74 207.05 501.5 207.05 475.83 207.05 475.83 223.34"
        />
        <path
          fill="#131943"
          d="M322.67,266H559.72a20.84,20.84,0,0,0,20.81-20.81v-191a20.84,20.84,0,0,0-20.81-20.81H322.67a20.84,20.84,0,0,0-20.81,20.81v191A20.83,20.83,0,0,0,322.67,266ZM303.86,54.15V52a18.77,18.77,0,0,1,5.74-13.52,18.41,18.41,0,0,0-3.09,10.23v.88a16.83,16.83,0,0,1,16.17-12.25H559.72A16.71,16.71,0,0,1,569,40.16h0l.69-.47a2,2,0,0,1,2.78.52,2,2,0,0,1-.34,2.65h0a16.78,16.78,0,0,1,3.74,6.72v-.87a18.4,18.4,0,0,0-3.09-10.23A18.77,18.77,0,0,1,578.53,52V243a18.84,18.84,0,0,1-11.92,17.53l-.11,0a16.7,16.7,0,0,1-6.78,1.44H322.67a16.7,16.7,0,0,1-6.78-1.44l-.11,0A18.84,18.84,0,0,1,303.86,243Z"
        />
        <path
          fill="#11163d"
          d="M570.56,41.32l.4.36c.34.3.67.62,1,1l.22.22a2,2,0,0,0-2.44-3.16l-.69.47,0,0A16.89,16.89,0,0,1,570.56,41.32Z"
        />
        <path
          fill="#e1e5e9"
          d="M552.65,48.41,539.13,45.9a2.05,2.05,0,0,0-.36,0A2,2,0,0,0,537,46.94L529.58,61a2,2,0,1,0,3.54,1.86l6.73-12.8L552,52.36a2,2,0,0,0-.07.31c-1.29,8.5-4.48,21.31-7.57,23.15a2,2,0,0,0,2,3.44c3.05-1.82,5.36-7.89,6.95-13.77l10.39,9.39a2,2,0,1,0,2.68-3l-12-10.84c.64-2.89,1.08-5.42,1.32-6.93l2.51-1.72a2,2,0,0,0,1.67-1.14L572,43l.16-.12h0l-.22-.22c-.31-.33-.64-.65-1-1l-.4-.36a16.89,16.89,0,0,0-1.49-1.13l0,0h0l-12,8.25Z"
        />
        <path
          fill="#e2e3e8"
          d="M306.17,50.93c-.08.42-.15.85-.2,1.29,0,.13,0,.27,0,.4,0,.5-.08,1-.08,1.53v191c0,.52,0,1,.08,1.54,0,.15,0,.29,0,.44q.07.57.17,1.14c0,.13,0,.27.08.4.1.49.23,1,.37,1.44l.07.2q.2.61.44,1.2l.17.4q.23.52.5,1l.16.31q.35.64.75,1.24l.18.26q.33.47.69.93l.28.34q.39.46.8.88l.18.19c.34.34.7.66,1.06,1l.3.23q.43.35.89.66l.36.24c.37.24.75.48,1.14.69l.11.06q.54.29,1.1.54l.11,0a18.78,18.78,0,0,0,6.81,1.27h237a18.79,18.79,0,0,0,6.81-1.27l.11,0q.56-.25,1.1-.54l.1-.06c.39-.22.77-.45,1.15-.7l.35-.24q.46-.32.89-.67l.29-.23c.37-.31.73-.63,1.07-1l.18-.19q.42-.43.81-.89l.28-.33q.36-.45.69-.93l.18-.25q.4-.6.75-1.24l.16-.31q.27-.51.5-1l.17-.4q.24-.59.44-1.2l.07-.2c.15-.47.27-1,.37-1.44,0-.13,0-.27.08-.4q.11-.56.17-1.14c0-.15,0-.29,0-.44,0-.51.08-1,.08-1.54v-191c0-.52,0-1-.08-1.53,0-.13,0-.27,0-.4,0-.43-.11-.86-.2-1.28,0-.07,0-.15,0-.22-.08-.4-.18-.8-.29-1.19V236a18.48,18.48,0,0,1-18.47,18.47H325A18.48,18.48,0,0,1,306.5,236V49.53c-.11.39-.21.79-.29,1.19C306.2,50.79,306.19,50.86,306.17,50.93Z"
        />
        <path
          fill="#11163d"
          d="M576.22,50.94c.08.42.15.85.2,1.28,0,.13,0,.27,0,.4,0,.5.08,1,.08,1.53v191c0,.52,0,1-.08,1.54,0,.15,0,.29,0,.44q-.07.58-.17,1.14c0,.13,0,.27-.08.4-.1.49-.23,1-.37,1.44l-.07.2q-.2.61-.44,1.2l-.17.4q-.23.53-.5,1l-.16.31q-.35.64-.75,1.24l-.18.25q-.33.48-.69.93l-.28.33q-.39.46-.81.89l-.18.19c-.34.34-.7.66-1.07,1l-.29.23q-.43.35-.89.67l-.35.24c-.37.25-.75.48-1.15.7l-.1.06q-.54.29-1.1.54A18.84,18.84,0,0,0,578.53,243V52a18.77,18.77,0,0,0-5.74-13.52,18.4,18.4,0,0,1,3.09,10.23v.81c.11.39.21.79.29,1.19C576.19,50.79,576.2,50.86,576.22,50.94Z"
        />
        <path
          fill="#11163d"
          d="M315.77,260.51q-.56-.25-1.1-.54l-.11-.06c-.39-.22-.77-.45-1.14-.69l-.36-.24q-.46-.32-.89-.66l-.3-.23c-.37-.31-.72-.63-1.06-1l-.18-.19q-.42-.43-.8-.88l-.28-.34q-.36-.45-.69-.93l-.18-.26q-.4-.6-.75-1.24l-.16-.31q-.26-.5-.5-1l-.17-.4q-.24-.59-.44-1.2l-.07-.2c-.15-.47-.27-1-.37-1.44,0-.13-.05-.27-.08-.4q-.11-.56-.17-1.14c0-.15,0-.29,0-.44,0-.51-.08-1-.08-1.54v-191c0-.52,0-1,.08-1.53,0-.13,0-.27,0-.4,0-.43.11-.86.2-1.29,0-.07,0-.14,0-.21.08-.4.18-.8.29-1.19v-.82a18.41,18.41,0,0,1,3.09-10.23A18.77,18.77,0,0,0,303.86,52V243A18.84,18.84,0,0,0,315.77,260.51Z"
        />
        <path
          fill="#131943"
          d="M323.86,283.88a6.33,6.33,0,1,0-2.65,5.13h0l0,0a6.29,6.29,0,0,0,2.59-4.73c0-.06,0-.12,0-.18S323.86,283.95,323.86,283.88Z"
        />
        <circle fill="#1fb575" cx="327.01" cy="56.43" r="6.31" />
        <circle fill="#131943" cx="346.92" cy="56.43" r="6.31" />
        <circle fill="#131943" cx="367.29" cy="56.43" r="6.31" />
        <polygon
          fill="#131943"
          points="408.05 277.57 408.05 290.19 410.05 290.19 412.05 290.19 412.05 277.57 410.05 277.57 408.05 277.57"
        />
        <polygon
          fill="#131943"
          points="420.51 277.57 420.51 290.19 422.51 290.19 424.51 290.19 424.51 277.57 422.51 277.57 420.51 277.57"
        />
        <polygon
          fill="#131943"
          points="432.96 277.57 432.96 290.19 434.96 290.19 436.96 290.19 436.96 277.57 434.96 277.57 432.96 277.57"
        />
        <polygon
          fill="#131943"
          points="445.42 277.57 445.42 290.19 447.42 290.19 449.42 290.19 449.42 277.57 447.42 277.57 445.42 277.57"
        />
        <polygon
          fill="#131943"
          points="457.88 277.57 457.88 290.19 459.88 290.19 461.88 290.19 461.88 277.57 459.88 277.57 457.88 277.57"
        />
        <polygon
          fill="#131943"
          points="470.34 277.57 470.34 290.19 472.34 290.19 474.34 290.19 474.34 277.57 472.34 277.57 470.34 277.57"
        />
        <rect
          fill="#131943"
          x="551.37"
          y="277.57"
          width="12.62"
          height="12.62"
        />
        <polygon
          fill="#1fb575"
          points="380.89 207.05 354.12 207.05 354.12 223.34 369.61 223.34 475.83 223.34 475.83 207.05 380.89 207.05"
        />
        <path
          fill="#131943"
          d="M395.75,177.41h94a2.49,2.49,0,0,0,2.16-3.74l-47-81.44a2.49,2.49,0,0,0-4.32,0l-47,81.44a2.49,2.49,0,0,0,2.16,3.74Zm50.76-29.33H439l-2.47-31.59H449Zm2.39,11.19a5.81,5.81,0,0,1-1.81,4.32,6,6,0,0,1-4.36,1.78,5.79,5.79,0,0,1-4.24-1.78,5.87,5.87,0,0,1-1.77-4.32,6,6,0,0,1,1.77-4.36,5.73,5.73,0,0,1,4.24-1.81,6.2,6.2,0,0,1,6.17,6.17Z"
        />
        <path
          fill="#fff"
          d="M438.49,154.91a6,6,0,0,0-1.77,4.36,5.87,5.87,0,0,0,1.77,4.32,5.79,5.79,0,0,0,4.24,1.78,6,6,0,0,0,4.36-1.78,5.81,5.81,0,0,0,1.81-4.32,6.2,6.2,0,0,0-6.17-6.17A5.73,5.73,0,0,0,438.49,154.91Z"
        />
        <polygon
          fill="#fff"
          points="436.56 116.49 439.02 148.08 446.51 148.08 448.98 116.49 436.56 116.49"
        />
        <path
          fill="#131943"
          d="M350.12,205v20.3a2,2,0,0,0,2,2H535.74a2,2,0,0,0,2-2V205a2,2,0,0,0-2-2H352.12A2,2,0,0,0,350.12,205Zm151.38,2h32.23v16.3H354.12V207H501.5Z"
        />
        <path
          fill="#fff"
          d="M800.25,288.22c-.94.59-2.77,3.13-2.77,10.71a29.15,29.15,0,0,0,3.17,12.76,29.24,29.24,0,0,0,3.18-12.76c0-7.59-1.83-10.12-2.77-10.71l-.43,0Z"
        />
        <path
          fill="#fff"
          d="M783.68,290.62c-3.61,3.6-4.36,9.79-4.39,14.14,2.19-2.59,5.31-6.13,8.88-9.69,5.29-5.27,5.7-8.26,5.7-9.06,0-.05,0-.1,0-.15a11,11,0,0,1-1-.92C791.5,284.91,788.51,285.8,783.68,290.62Z"
        />
        <path
          fill="#fff"
          d="M822,277.1a34.49,34.49,0,0,0-4.84-.38c-3.12,0-4.83.6-5.68,1.16a10.78,10.78,0,0,1-.22,1.82c.72.8,3.08,2.68,9.85,3.64,5,.71,9.6,1.67,12.91,2.44C831.34,282.31,827,277.82,822,277.1Z"
        />
        <path
          fill="#131943"
          d="M840.28,288c-.3-.55-7.41-13.41-17.74-14.88-5.4-.77-9.2-.39-11.73.61a10.8,10.8,0,0,0-2-3.37c2.34-1.82,4.55-5.12,6.48-9.74a156.47,156.47,0,0,1,7.88-16,2,2,0,0,0-2.21-2.94c-.6.15-14.84,3.79-18.86,13.42h0c-2.11,5.06-2.7,8.85-2.36,11.54a10.82,10.82,0,0,0-6.86,3.21c-2-2-5.62-3.76-11.59-4.83-10.28-1.83-21,8.16-21.5,8.59a2,2,0,0,0,1.28,3.46,156.14,156.14,0,0,1,17.72,2l.48.08a46.27,46.27,0,0,0-16.38,11.32c-11.83,12.59-16.64,30.83-18.59,43.91-.62,4.15-1,8-1.23,11.46-1.47-14.52-7.26-35.72-28.15-40.9a2,2,0,1,0-1,3.88c27.62,6.85,25.74,46.16,25.45,50.41H705.12a2,2,0,0,0-2,2V379.5a2,2,0,0,0,2,2h.39l1.16,10.34.78,7,1.62,14.42.31,2.75.14,1.26.31,2.74c0,.06,0,.13,0,.19h-43V360a15.09,15.09,0,0,0-15.07-15.07H550.47a15.74,15.74,0,0,0-15.7-15.21H524.64c-1.2-12.74-3.66-19.38-5.81-22.82h74.91A18.28,18.28,0,0,0,612,288.63V144.81l42.78,4.14H655a2,2,0,0,0,1.78-2.91c0-.09-4.36-8.85-2.82-24.78l3.1-32a2,2,0,0,0-1.8-2.18L612,82.89V20.13A18.28,18.28,0,0,0,593.74,1.88H288.65a18.28,18.28,0,0,0-18.26,18.26V166l-32.9.65a2,2,0,0,0-2,2l.63,32.16c.32,16-4.66,24.41-4.7,24.49a2,2,0,0,0,1.7,3h0l37.18-.73v61a18.39,18.39,0,0,0,11.07,16.78l.09,0a18.11,18.11,0,0,0,5.37,1.35h.13c.53,0,1.06.08,1.6.08h86.22A81.22,81.22,0,0,0,396,327.72q1.52,1,3.1,2H347.62c-.25,0-.49,0-.73,0h-.26a15.62,15.62,0,0,0-4.9,1.11l-.38.16a15.8,15.8,0,0,0-6.24,4.93,15.4,15.4,0,0,0-3.19,9H230.56A15.09,15.09,0,0,0,215.5,360v96.3s0,0,0,0c0,.34,0,.67.05,1s.07.76.12,1.13l0,.25c.06.38.14.75.23,1.12s.13.56.21.83a15,15,0,0,0,.67,1.78h0l.05.11a15.08,15.08,0,0,0,13.69,8.8H651.83a15,15,0,0,0,2.52-.23H781.06a9.45,9.45,0,0,0,8.54-5.43h.64a4.8,4.8,0,0,0,4.8-4.8V449.26s0-.06,0-.09,0-.05,0-.08L792.78,422a2,2,0,0,0-2-1.84H777.1c0-.06,0-.13,0-.19l4.32-38.48h.39a2,2,0,0,0,2-2V361.28a2,2,0,0,0-2-2h-35c-.2-4.56-1.28-44.48,19-66a42.82,42.82,0,0,1,24.35-13,10.75,10.75,0,0,0,.34,1c-2.6.73-5.84,2.7-9.65,6.5-7.38,7.36-5.33,21.9-5.24,22.52a2,2,0,0,0,1.47,1.64,2,2,0,0,0,.5.06,2,2,0,0,0,1.58-.78A155.54,155.54,0,0,1,791,297.91c1-1,1.88-2,2.67-2.93-.12,1.2-.19,2.51-.19,3.94A33.49,33.49,0,0,0,799,316.84a2,2,0,0,0,3.25,0,33.5,33.5,0,0,0,5.55-17.91c0-5.69-1-9.47-2.45-11.79a10.9,10.9,0,0,0,4.18-3.58c2.35,1.77,6.07,3.06,11,3.76A156.15,156.15,0,0,1,838,290.9a2,2,0,0,0,.54.07,2,2,0,0,0,1.76-3ZM646.16,395.3v24.88H550.57v-50.4a3.72,3.72,0,0,1,3.72-3.72h88.15a3.72,3.72,0,0,1,3.72,3.72ZM472.3,424.18H788.95l1.92,23.09H470.38Zm192.6-43.36v39.36h-.34V357.11a13,13,0,0,1,.34,2.87ZM341.06,335.74a11.67,11.67,0,0,1,3-1.45q.51-.17,1-.29a11.69,11.69,0,0,1,2.56-.29H534.77a11.75,11.75,0,0,1,11.62,10.11H336A11.74,11.74,0,0,1,341.06,335.74ZM650,120.88c-1.12,11.59.65,19.64,2,23.77L612,140.79l-1.43-.14-.57-.05-2-.19-9-.87c-1.05-2.66-3.65-10.8-2.4-23.81l2.21-22.87.69-7.15,8.52.82,2,.19,2,.19,40.86,3.95ZM240.17,200.77l-.6-30.16,30.82-.61,2,0,2,0,18.8-.37.14,7.1.45,23.05c.26,13-3,21-4.22,23.56l-15.18.3h-.33l-1.68,0-2,0-34,.67C238,220.3,240.4,212.41,240.17,200.77ZM373.52,304.88H282.35l-.44,0h-.09a5.94,5.94,0,0,1-5.33-5q0-.29-.07-.58c0-.12,0-.25,0-.37l-2.19-5.16a6,6,0,0,1-1.81-4.28l0,.12,1.76,4.16a6,6,0,0,0,1.64,1.13h0a14.15,14.15,0,0,1-1.48-6.28V234h-.12l-.13-6.45h.25l16.44-.32a2,2,0,0,0,1.66-1,33.07,33.07,0,0,0,3-7.54,64.47,64.47,0,0,0,2.28-19.12l-.63-32.16a2,2,0,0,0-.61-1.4,2.05,2.05,0,0,0-1.43-.56l-20.72.41V20.13A14.27,14.27,0,0,1,288.65,5.88H593.74A14.27,14.27,0,0,1,608,20.13V82.5l-10.13-1a2,2,0,0,0-2.18,1.8l-.88,9.14-2.21,22.87c-1.66,17.21,3,26.6,3.24,27a2,2,0,0,0,1.59,1.08l10.58,1,2,.19.18,0-.18,1.9-.44,4.6L608,151V288.63a14.15,14.15,0,0,1-1.48,6.28h0a6,6,0,0,0,1.64-1.13l1.76-4.16,0-.12a6,6,0,0,1-1.81,4.28L606,298.94c0,.13,0,.25,0,.37a5.94,5.94,0,0,1-5.93,5.57H373.52Zm140.26,2,0,.12-.11-.05c.06,0,5,3.07,7,22.75H483.34a81.19,81.19,0,0,0,24.18-22.82ZM230.56,469.35a13.06,13.06,0,0,1-11.88-7.65h0a13,13,0,0,1-1-3v-.11a13.1,13.1,0,0,1-.21-2.24V360a13.07,13.07,0,0,1,.34-2.87v89.66a13.49,13.49,0,0,0,1.66,6.37V360a11.08,11.08,0,0,1,11.07-11.07H651.83A11.08,11.08,0,0,1,662.89,360v60.19H650.16v-50.4a7.73,7.73,0,0,0-7.72-7.72H554.29a7.73,7.73,0,0,0-7.72,7.72v50.4H470.46a2,2,0,0,0-2,1.84l-2.25,27.09s0,.05,0,.08,0,.06,0,.09v11.63a4.8,4.8,0,0,0,4.8,4.8h.64l.11.22c.08.16.16.31.25.46l.22.36.29.43.14.19h0l.09.1a9.51,9.51,0,0,0,.83.95l.11.1a9.5,9.5,0,0,0,.89.75l.12.1ZM793,460.89v.9H468.21V449.26H793v11.63Zm-17.79-41.13q0,.21-.06.41H713.94a4,4,0,0,1-.13-.64l-.16-1.43-.13-1.19-.36-3.16-.09-.83-1.21-10.81-.59-5.3-1.65-14.69h59.7l.07-.64.15-1.36h10.15l-.15,1.36Zm6.6-58.48v17.16h-6.61v-.94H707.12V363.28h68.11v-2Zm39.23-77.93c-6.77-1-9.13-2.84-9.85-3.64a10.78,10.78,0,0,0,.22-1.82c.85-.56,2.56-1.16,5.68-1.16a34.49,34.49,0,0,1,4.84.38c5,.72,9.37,5.21,12,8.68C830.68,285,826.06,284.06,821.08,283.35Zm-19.51.82a6.17,6.17,0,0,1-1.85,0,6.81,6.81,0,0,1-2.5-.85,6.88,6.88,0,0,1-2.13-1.92,6.71,6.71,0,0,1-1.26-4.71,6.94,6.94,0,0,1,1-2.8,6.84,6.84,0,0,1,12.6,2.52,6.59,6.59,0,0,1-.46,3.67A6.86,6.86,0,0,1,801.57,284.17Zm2.26,14.76a29.24,29.24,0,0,1-3.18,12.76,29.15,29.15,0,0,1-3.17-12.76c0-7.58,1.83-10.11,2.77-10.71l.38,0,.43,0C802,288.81,803.82,291.33,803.82,298.93Zm-10-12.91c0,.79-.41,3.79-5.7,9.06-3.57,3.55-6.69,7.09-8.88,9.69,0-4.35.77-10.54,4.39-14.14,4.83-4.82,7.82-5.71,9.17-5.67a11,11,0,0,0,1,.92C793.87,285.92,793.87,286,793.87,286Zm-13.28-17h0c7,1.25,9.36,3.28,10,4.38a10.71,10.71,0,0,0-.45,1.37,5,5,0,0,1-1.37.59c-1.49.43-4.32.76-9.27-.12s-9.64-1.42-13-1.72C770.07,271,775.59,268.08,780.59,269Zm25.21-12.32c2-4.69,7.4-7.75,11.42-9.44-1.57,3-3.67,7.24-5.61,11.88-2.75,6.58-5.25,8.27-6.12,8.68a10.78,10.78,0,0,0-1.56-.65c-.5-1.33-.67-4.43,1.86-10.47Z"
        />
        <path
          fill="#fff"
          d="M779.5,275.19c5,.88,7.78.56,9.27.12a5,5,0,0,0,1.37-.59,10.71,10.71,0,0,1,.45-1.37c-.63-1.1-3-3.13-10-4.38h0c-5-.89-10.52,2-14.12,4.49C769.85,273.77,774.54,274.3,779.5,275.19Z"
        />
        <path
          fill="#fff"
          d="M803.94,267.13a10.78,10.78,0,0,1,1.56.65c.87-.41,3.37-2.1,6.12-8.68,1.94-4.64,4-8.87,5.61-11.88-4,1.69-9.46,4.75-11.42,9.44h0C803.27,262.7,803.44,265.8,803.94,267.13Z"
        />
        <path
          fill="#fafafa"
          d="M765,382.14H709.61l1.65,14.69.59,5.3,1.21,10.81.09.83.36,3.16.13,1.19.16,1.43a4,4,0,0,0,.13.64H765l4.27-38Z"
        />
        <rect
          fill="#fafafa"
          x="707.12"
          y="363.28"
          width="68.11"
          height="14.22"
        />
        <path
          fill="#fff"
          d="M807.39,276.41a6.84,6.84,0,0,0-13.38-.72,6.71,6.71,0,0,0-.19,1,6.8,6.8,0,0,0,1.26,4.71,6.88,6.88,0,0,0,2.13,1.92,7.06,7.06,0,0,0,3.41.92,6.95,6.95,0,0,0,6.3-4.15,6.59,6.59,0,0,0,.46-3.67Z"
        />
        <path
          fill="#dedfe4"
          d="M777.36,382.14h-8l-4.27,38h8a4.08,4.08,0,0,0,.12-.64Z"
        />
        <path
          fill="#11163d"
          d="M779.59,380.14H769.54l-.15,1.36-.07.64h8l-4.2,37.4a4.08,4.08,0,0,1-.12.64h2.15q0-.2.06-.41l4.29-38.26.15-1.36Z"
        />
        <rect
          fill="#dedfe4"
          x="775.24"
          y="363.28"
          width="4.61"
          height="14.22"
        />
        <polygon
          fill="#11163d"
          points="779.85 363.28 779.85 377.5 775.24 377.5 775.24 378.14 775.24 378.44 780.63 378.44 781.85 378.44 781.85 361.28 775.24 361.28 775.24 363.28 779.85 363.28"
        />
        <path fill="#fafafa" d="M472.65,467.35l-.14-.19.13.19Z" />
        <path fill="#fafafa" d="M471.65,465.69h0l.12.22Z" />
        <path
          fill="#fafafa"
          d="M221,455.25a13,13,0,0,0,9.92,4.57H466.21V449.26s0-.06,0-.09,0-.05,0-.08L468.46,422a2,2,0,0,1,2-1.84h76.12v-50.4a7.73,7.73,0,0,1,7.72-7.72h88.15a7.73,7.73,0,0,1,7.72,7.72v50.4h12.74V360a11.08,11.08,0,0,0-11.07-11.07H230.56A11.08,11.08,0,0,0,219.5,360v93.16l0,.07A13.08,13.08,0,0,0,221,455.25ZM458.9,369.17H483v11H458.9Zm-24.06,0h11v11h-11ZM236.05,390V367.33a2,2,0,0,1,2-2H410.49a2,2,0,0,1,2,2v82.91a2,2,0,0,1-2,2H238.05a2,2,0,0,1-2-2V390Z"
        />
        <path
          fill="#dedfe4"
          d="M219.5,456.28a11.11,11.11,0,0,0,11.07,11.07H472.64l-.13-.19-.29-.43-.22-.36c-.09-.15-.17-.3-.25-.46l-.12-.22H471a4.8,4.8,0,0,1-4.8-4.8v-1.07H230.88a13,13,0,0,1-11.35-6.6l0-.07v3.14Z"
        />
        <path
          fill="#11163d"
          d="M664.55,380.58v39.59h.34V360a13,13,0,0,0-.34-2.87Z"
        />
        <path
          fill="#11163d"
          d="M473.67,468.5l-.11-.1a9.51,9.51,0,0,1-.83-.95l-.09-.1H230.56a11.11,11.11,0,0,1-11.07-11.07v-3.14a13.49,13.49,0,0,1-1.66-6.37V357.11a13.07,13.07,0,0,0-.34,2.87v96.3a13.1,13.1,0,0,0,.21,2.24v.11a13,13,0,0,0,1,3h0a13.06,13.06,0,0,0,11.88,7.65H474.68l-.12-.1A9.5,9.5,0,0,1,473.67,468.5Z"
        />
        <path
          fill="#fff"
          d="M240.05,392.07v56.16H408.49V369.33H240.05v22.75Zm107.8,48.61A6.19,6.19,0,1,1,354,434.5,6.19,6.19,0,0,1,347.85,440.68ZM373,440H362V429h11Zm19,0H381V429h11Zm-139.8-57.62a2,2,0,0,1,2-2H395.68a2,2,0,0,1,2,2v36.3a2,2,0,0,1-2,2H254.14a2,2,0,0,1-2-2Z"
        />
        <path
          fill="#131943"
          d="M236.05,399.93v50.3a2,2,0,0,0,2,2H410.49a2,2,0,0,0,2-2V367.33a2,2,0,0,0-2-2H238.05a2,2,0,0,0-2,2v32.6Zm4-15.7v-14.9H408.49v78.91H240.05v-64Z"
        />
        <path
          fill="#131943"
          d="M254.14,420.66H395.68a2,2,0,0,0,2-2v-36.3a2,2,0,0,0-2-2H254.14a2,2,0,0,0-2,2v36.3A2,2,0,0,0,254.14,420.66Zm0-38.3H395.68v36.3H254.14Z"
        />
        <path
          fill="#eaeaee"
          d="M256.14,416.66H393.68v-32.3H256.14Zm9.11-20.79h30.2V393H353v2.91h30.2v8.43H353v2.91H295.45V404.3h-30.2Z"
        />
        <path
          fill="#11173f"
          d="M395.68,382.36H254.14v36.3H395.68Zm-2,34.3H256.14v-32.3H393.68Z"
        />
        <circle fill="#1fb575" cx="347.85" cy="434.5" r="6.19" />
        <polygon
          fill="#131943"
          points="295.45 407.21 352.96 407.21 352.96 404.3 383.15 404.3 383.15 395.87 352.96 395.87 352.96 392.95 295.45 392.95 295.45 395.87 265.25 395.87 265.25 404.3 295.45 404.3 295.45 407.21"
        />
        <rect
          fill="#1fb575"
          x="380.98"
          y="429.02"
          width="10.96"
          height="10.96"
        />
        <rect
          fill="#131943"
          x="362.03"
          y="429.02"
          width="10.96"
          height="10.96"
        />
        <rect
          fill="#131943"
          x="458.9"
          y="369.17"
          width="24.13"
          height="10.96"
        />
        <rect
          fill="#131943"
          x="434.84"
          y="369.17"
          width="10.96"
          height="10.96"
        />
        <path
          fill="#fff"
          d="M642.44,366.05H554.29a3.72,3.72,0,0,0-3.72,3.72v50.4h95.58v-50.4A3.72,3.72,0,0,0,642.44,366.05Zm-72.59,44.64h-4V377.32h4Zm12.46,0h-4V377.32h4Zm12.46,0h-4V377.32h4Zm12.46,0h-4V377.32h4v33.37Zm12.46,0h-4V377.32h4v33.37Zm12.46-3.06v3.06h-4V377.32h4v30.31Z"
        />
        <polygon
          fill="#131943"
          points="565.85 377.32 565.85 410.69 567.85 410.69 569.85 410.69 569.85 377.32 567.85 377.32 565.85 377.32"
        />
        <polygon
          fill="#131943"
          points="578.31 377.32 578.31 410.69 580.31 410.69 582.31 410.69 582.31 377.32 580.31 377.32 578.31 377.32"
        />
        <polygon
          fill="#131943"
          points="590.77 377.32 590.77 410.69 592.77 410.69 594.77 410.69 594.77 377.32 592.77 377.32 590.77 377.32"
        />
        <polygon
          fill="#131943"
          points="607.23 377.32 605.23 377.32 603.23 377.32 603.23 410.69 605.23 410.69 607.23 410.69 607.23 397.63 607.23 393.71 607.23 377.32"
        />
        <polygon
          fill="#131943"
          points="619.69 400.31 619.69 400.21 619.69 377.32 617.69 377.32 615.69 377.32 615.69 397.96 615.69 398.08 615.69 402.6 615.69 402.67 615.69 410.69 617.69 410.69 619.69 410.69 619.69 404.95 619.69 404.53 619.69 400.31"
        />
        <polygon
          fill="#131943"
          points="632.15 377.32 630.15 377.32 628.15 377.32 628.15 402.22 628.15 405.28 628.15 406.23 628.15 409.93 628.15 410.69 629.45 410.69 630.15 410.69 632.15 410.69 632.15 407.63 632.15 406.11 632.15 402.09 632.15 377.32"
        />
        <path
          fill="#fff"
          d="M548.57,447.26H790.87l-1.92-23.09H472.3l-1.92,23.09h78.19Zm204.92-6.91h-4V435.2H735.14v5.15h-4V433.2a2,2,0,0,1,2-2h18.35a2,2,0,0,1,2,2Zm25.65-9.15a2,2,0,0,1,2,2v7.15h-4V435.2H762.8v5.15h-4V433.2a2,2,0,0,1,2-2Zm-75.66,2a2,2,0,0,1,2-2h18.35a2,2,0,0,1,2,2v7.15h-4V435.2H707.49v5.15h-4Zm-21.45-2h14.15a2,2,0,0,1,2,2v7.15h-4V435.2H679.83v1.26h0v.72h0v3.15h-4V433.2a2,2,0,0,1,1.95-2H682Zm-33.86,2a2,2,0,0,1,2-2h18.37a2,2,0,0,1,2,2v7.15h-4V435.2H652.18v5.15h-4Zm-27.65,0a2,2,0,0,1,2-2h18.35a2,2,0,0,1,2,2v7.15h-4V435.2H624.53v5.15h-4Zm-27.65,0a2,2,0,0,1,2-2h18.35a2,2,0,0,1,2,2v7.15h-4V435.2H596.87v5.15h-4Zm-27.65,0a2,2,0,0,1,2-2h18.35a2,2,0,0,1,2,2v7.15h-4V435.2H569.22v5.15h-4Zm-60.61,7.15h-4V435.2H486.25v5.15h-4V433.2a2,2,0,0,1,2-2H502.6a2,2,0,0,1,2,2Zm27.65,0h-4V435.2H513.91v5.15h-4V433.2a2,2,0,0,1,2-2h18.35a2,2,0,0,1,2,2Zm7.31,0h-2V433.2a2,2,0,0,1,2-2h18.35a2,2,0,0,1,2,2v7.15h-4V435.2H541.56v5.15Z"
        />
        <path
          fill="#e2e3e8"
          d="M664.89,451.26H470.21v9.63a.79.79,0,0,0,.53.74.78.78,0,0,0,.26.05H790.24a.78.78,0,0,0,.26-.05.79.79,0,0,0,.53-.74v-9.63H664.89Z"
        />
        <path
          fill="#11163d"
          d="M666.89,449.26H468.21v12.53H793V449.26ZM791,460.89a.79.79,0,0,1-.53.74.78.78,0,0,1-.26.05H471a.78.78,0,0,1-.26-.05.79.79,0,0,1-.53-.74v-9.63H791Z"
        />
        <path
          fill="#131943"
          d="M758.8,433.2v7.15h4V435.2h14.35v5.15h4V433.2a2,2,0,0,0-2-2H760.8A2,2,0,0,0,758.8,433.2Z"
        />
        <path
          fill="#131943"
          d="M751.49,431.2H733.14a2,2,0,0,0-2,2v7.15h4V435.2h14.35v5.15h4V433.2A2,2,0,0,0,751.49,431.2Z"
        />
        <path
          fill="#131943"
          d="M707.49,440.35V435.2h14.35v5.15h4V433.2a2,2,0,0,0-2-2H705.49a2,2,0,0,0-2,2v7.15h4Z"
        />
        <path
          fill="#131943"
          d="M677.83,431.2h-.05a2,2,0,0,0-1.95,2v7.15h4V437.2h0v-.72h0V435.2h14.35v5.15h4V433.2a2,2,0,0,0-2-2H677.83Z"
        />
        <path
          fill="#131943"
          d="M650.18,440.35h2V435.2h14.35v5.15h4V433.2a2,2,0,0,0-2-2H650.16a2,2,0,0,0-2,2v7.15h2Z"
        />
        <path
          fill="#131943"
          d="M624.53,440.35V435.2h14.35v5.15h4V433.2a2,2,0,0,0-2-2H622.53a2,2,0,0,0-2,2v7.15h4Z"
        />
        <path
          fill="#131943"
          d="M596.87,440.35V435.2h14.35v5.15h4V433.2a2,2,0,0,0-2-2H594.87a2,2,0,0,0-2,2v7.15h4Z"
        />
        <path
          fill="#131943"
          d="M569.22,440.35V435.2h14.35v5.15h4V433.2a2,2,0,0,0-2-2H567.22a2,2,0,0,0-2,2v7.15h4Z"
        />
        <path
          fill="#131943"
          d="M546.57,435.2h9.34v5.15h4V433.2a2,2,0,0,0-2-2H539.56a2,2,0,0,0-2,2v7.15h4V435.2Z"
        />
        <path
          fill="#131943"
          d="M530.26,431.2H511.91a2,2,0,0,0-2,2v7.15h4V435.2h14.35v5.15h4V433.2A2,2,0,0,0,530.26,431.2Z"
        />
        <path
          fill="#131943"
          d="M502.6,431.2H484.25a2,2,0,0,0-2,2v7.15h4V435.2H500.6v5.15h4V433.2A2,2,0,0,0,502.6,431.2Z"
        />
        <path
          fill="#dedfe4"
          d="M588.12,149.06,608,151v-6.56l-10.58-1a2,2,0,0,1-1.59-1.08c-.2-.39-4.9-9.78-3.24-27l2.21-22.87-1.2-.12Z"
        />
        <polygon
          fill="#11163d"
          points="609.55 151.13 610 146.53 610.18 144.63 610 144.61 608 144.42 608 150.98 609.55 151.13"
        />
        <path
          fill="#fff"
          d="M610,86.71l-2-.19-8.52-.82-.69,7.15-2.21,22.87c-1.26,13,1.34,21.15,2.4,23.81l9,.87,2,.19.57.05,1.43.14,39.94,3.86c-1.33-4.13-3.1-12.18-2-23.77l2.9-30L612,86.91Zm6.47,22.46a7,7,0,0,1,.81-2.73,7.31,7.31,0,0,1,1.72-2.11,8.51,8.51,0,0,1,2.41-1.42,9.18,9.18,0,0,1,2.88-.61l.39-4,3.83.37-.4,4.13a8.91,8.91,0,0,1,2.7,1.25,8.42,8.42,0,0,1,1.84,1.73,7.3,7.3,0,0,1,1.1,2,8.42,8.42,0,0,1,.47,2l-4.74.87a4.92,4.92,0,0,0-.22-1.12,3.78,3.78,0,0,0-.64-1.22,4.07,4.07,0,0,0-1.19-1,4.61,4.61,0,0,0-1.9-.54,4,4,0,0,0-2.84.62,2.72,2.72,0,0,0-1.16,2,2.19,2.19,0,0,0,.49,1.6,3.8,3.8,0,0,0,1.86,1.17l3.34,1.12a9.26,9.26,0,0,1,5,3.25,6.81,6.81,0,0,1,1.21,4.67,7.18,7.18,0,0,1-.69,2.47,6.89,6.89,0,0,1-1.57,2.07,8.09,8.09,0,0,1-2.36,1.48,9.35,9.35,0,0,1-3.08.67l-.39,4.05-3.83-.37.39-4a10,10,0,0,1-3.31-1.38,9.17,9.17,0,0,1-2.26-2.09,8.34,8.34,0,0,1-1.29-2.48,8.06,8.06,0,0,1-.42-2.52l4.76-.68a5.33,5.33,0,0,0,.27,1.75,4.75,4.75,0,0,0,.85,1.54,4.67,4.67,0,0,0,1.48,1.17,6.11,6.11,0,0,0,2.22.59,4.59,4.59,0,0,0,2.93-.51,2.47,2.47,0,0,0,1.21-1.93,2.29,2.29,0,0,0-.53-1.74,4.18,4.18,0,0,0-2-1.2l-3.38-1.09a9.28,9.28,0,0,1-4.56-3A6.34,6.34,0,0,1,616.46,109.17Z"
        />
        <path
          fill="#1fb575"
          d="M622.35,116.86l3.38,1.09a4.18,4.18,0,0,1,2,1.2,2.29,2.29,0,0,1,.53,1.74,2.47,2.47,0,0,1-1.21,1.93,4.59,4.59,0,0,1-2.93.51,6.11,6.11,0,0,1-2.22-.59,4.67,4.67,0,0,1-1.48-1.17,4.75,4.75,0,0,1-.85-1.54,5.33,5.33,0,0,1-.27-1.75l-4.76.68a8.06,8.06,0,0,0,.42,2.52,8.34,8.34,0,0,0,1.29,2.48,9.17,9.17,0,0,0,2.26,2.09,10,10,0,0,0,3.31,1.38l-.39,4,3.83.37.39-4.05a9.35,9.35,0,0,0,3.08-.67,8.09,8.09,0,0,0,2.36-1.48,6.89,6.89,0,0,0,1.57-2.07,7.18,7.18,0,0,0,.69-2.47,6.81,6.81,0,0,0-1.21-4.67,9.26,9.26,0,0,0-5-3.25L623.88,112a3.8,3.8,0,0,1-1.86-1.17,2.19,2.19,0,0,1-.49-1.6,2.72,2.72,0,0,1,1.16-2,4,4,0,0,1,2.84-.62,4.61,4.61,0,0,1,1.9.54,4.07,4.07,0,0,1,1.19,1,3.78,3.78,0,0,1,.64,1.22,4.92,4.92,0,0,1,.22,1.12l4.74-.87a8.42,8.42,0,0,0-.47-2,7.3,7.3,0,0,0-1.1-2,8.42,8.42,0,0,0-1.84-1.73,8.91,8.91,0,0,0-2.7-1.25l.4-4.13-3.83-.37-.39,4a9.18,9.18,0,0,0-2.88.61,8.51,8.51,0,0,0-2.41,1.42,7.31,7.31,0,0,0-1.72,2.11,7,7,0,0,0-.81,2.73,6.34,6.34,0,0,0,1.32,4.71A9.28,9.28,0,0,0,622.35,116.86Z"
        />
        <path
          fill="#dedfe4"
          d="M295.51,218.75a33.07,33.07,0,0,1-3,7.54,2,2,0,0,1-1.66,1l-16.44.32V234l21.41-.42Z"
        />
        <polygon
          fill="#11163d"
          points="274.15 227.57 274.28 234.02 274.39 234.02 274.39 227.57 274.15 227.57"
        />
        <path
          fill="#fff"
          d="M272.4,223.61l1.68,0h.33l15.18-.3c1.25-2.59,4.47-10.57,4.22-23.56l-.45-23.05-.14-7.1-18.8.37-2,0-2,0-30.82.61.6,30.16c.23,11.65-2.15,19.53-3.79,23.55l34-.67ZM259,219.17l3-18.69-8-.53,16.32-23.56.94-1.36-.94,5.49-2.26,13.19,2.26.15,2,.13,1.09.07.91.06,2,.13-2,2.88-.82,1.18L272.4,200l-2,2.87Z"
        />
        <polygon
          fill="#1fb575"
          points="272.39 200.02 273.57 198.33 274.39 197.15 276.4 194.26 274.39 194.13 273.49 194.07 272.39 194 270.39 193.86 268.13 193.71 270.39 180.52 271.33 175.04 270.39 176.39 254.08 199.95 262.05 200.49 259.05 219.17 270.39 202.89 272.39 200.02"
        />
        <path
          fill="#e1e5e9"
          d="M340.78,343.82H546.39a11.75,11.75,0,0,0-11.62-10.11H347.62a11.69,11.69,0,0,0-2.56.29q-.53.12-1,.29a11.78,11.78,0,0,0-8,9.53h4.77Z"
        />
        <path
          fill="#fafafa"
          d="M168,294.68h-4.6c-.7,0-1.79.06-3.15.17a3.5,3.5,0,0,0-.42,1.69,3.72,3.72,0,0,0,.64,2.11c.56-.05,1.1-.09,1.57-.09h4.42a10.51,10.51,0,0,1,10.5,10.5v15.33a16.16,16.16,0,0,1-14.06,16l-.38,0-1.75.25-1.09.15-.32,0-1.14.14-.26,0-1.18.1h-.14a5.46,5.46,0,0,0-.84,2.33A8,8,0,0,0,156,346l11.23-3.34a18.12,18.12,0,0,0,12.88-17.26V306.79A12.13,12.13,0,0,0,168,294.68Z"
        />
        <path
          fill="#fff"
          d="M99.39,370.31H130a11,11,0,0,0,4.37-5.89c2.4-7.88,7.89-39.73,7.89-66.1v-11.1a4.61,4.61,0,0,0-.83-2.64h-56a2.64,2.64,0,0,0-2.64,2.64v11.1c0,26.31,5.47,57.85,7.81,65.52A9.13,9.13,0,0,0,99.39,370.31Z"
        />
        <path
          fill="#e7e8ec"
          d="M142.28,298.31c0,26.37-5.5,58.23-7.89,66.1a11,11,0,0,1-4.37,5.89h3.8a9.13,9.13,0,0,0,8.81-6.47c.64-2.09,1.51-6,2.43-11,.13-.73.27-1.47.4-2.25.17-1,.34-2,.52-3,.45-2.76.91-5.74,1.34-8.89l.06-.43a327.73,327.73,0,0,0,2.93-33.14q0-.68,0-1.36c0-1.82.07-3.62.07-5.4v-11.1a2.64,2.64,0,0,0-2.64-2.64h-6.35a4.61,4.61,0,0,1,.83,2.64Z"
        />
        <path
          fill="#131943"
          d="M99.39,374.31h34.43A13.11,13.11,0,0,0,146.46,365a129.65,129.65,0,0,0,2.77-12.79l19.12-5.69a22.15,22.15,0,0,0,15.74-21.1V306.79A16.13,16.13,0,0,0,168,290.68h-4.6c-2.11,0-6.18.42-8.93.72v-4.19a6.65,6.65,0,0,0-6.64-6.64H85.4a6.65,6.65,0,0,0-6.64,6.64v11.1c0,26.7,5.59,58.85,8,66.69A13.11,13.11,0,0,0,99.39,374.31Zm-16.62-87.1a2.64,2.64,0,0,1,2.64-2.64h62.4a2.64,2.64,0,0,1,2.64,2.64v11.1c0,1.78,0,3.58-.07,5.4q0,.68,0,1.36a327.73,327.73,0,0,1-2.93,33.14l-.06.43c-.44,3.15-.89,6.13-1.34,8.89-.17,1-.34,2.07-.52,3-.14.78-.27,1.52-.4,2.25-.93,5-1.8,8.91-2.43,11a9.13,9.13,0,0,1-8.81,6.47H99.39a9.13,9.13,0,0,1-8.81-6.47c-2.33-7.67-7.81-39.21-7.81-65.52Zm97.32,38.21a18.12,18.12,0,0,1-12.88,17.26L156,346a8,8,0,0,1-.22-2.55,5.46,5.46,0,0,1,.84-2.33h.14l1.18-.1.26,0,1.14-.14.32,0,1.09-.15,1.75-.25.38,0a16.16,16.16,0,0,0,14.06-16V309.05a10.51,10.51,0,0,0-10.5-10.5H162c-.47,0-1,0-1.57.09a3.72,3.72,0,0,1-.64-2.11,3.5,3.5,0,0,1,.42-1.69c1.36-.11,2.45-.17,3.15-.17H168a12.13,12.13,0,0,1,12.11,12.11ZM154.3,305.91a4.94,4.94,0,0,1,3.32-2.77,21.67,21.67,0,0,1,4.39-.58h4.42a6.51,6.51,0,0,1,6.5,6.5v15.33a12.15,12.15,0,0,1-10.57,12l-.38,0-1.82.25c-3.28.47-6.17.87-8.5-.25C152.9,327,153.94,316.24,154.3,305.91Z"
        />
        <path
          fill="#fff"
          d="M898,438.39a11.12,11.12,0,0,0-6.42-2H855.65a11.2,11.2,0,0,0-11.09,9.72H898.2v-5.51A9.72,9.72,0,0,0,898,438.39Z"
        />
        <path
          fill="#fff"
          d="M894.24,461.83a4,4,0,0,0,4-4v-7.8H844.46v11.73l.45,0Z"
        />
        <path
          fill="#131943"
          d="M891.54,432.36H855.65a15.21,15.21,0,0,0-15.19,15.19v.52h0v14.18a8.38,8.38,0,0,0,8.37,8.37h49.54a8.38,8.38,0,0,0,8.37-8.37V447.55A15.21,15.21,0,0,0,891.54,432.36Zm6.81,3.91.2.12c.22.14.44.29.66.44l.18.14a13.27,13.27,0,0,1,1.28,1.08l0,0c.17.16.33.33.49.5l.28.31.41.49.31.42c.16.22.31.44.46.66s.27.43.4.66l.23.43q.16.3.3.62l.18.42q.17.43.32.87l.07.2c.11.36.2.73.28,1.11,0,.12,0,.24.07.36q.08.43.13.86v.09H844.57a11.2,11.2,0,0,1,11.09-9.72h35.88a11.12,11.12,0,0,1,6.42,2h0a10.54,10.54,0,0,0-1.17-2.92h0A13.21,13.21,0,0,1,898.34,436.26Zm6.39,26a6.37,6.37,0,0,1-6.37,6.37H848.83a6.37,6.37,0,0,1-6.37-6.37V461a4,4,0,0,0,2,.85V450.08h60.27Z"
        />
        <path
          fill="#e2e3e8"
          d="M902.43,445c0-.15-.07-.29-.11-.43s-.16-.53-.25-.79-.09-.27-.15-.4c-.12-.3-.26-.6-.41-.88l-.11-.23a11.2,11.2,0,0,0-.64-1l-.19-.25c-.18-.24-.36-.48-.56-.71l-.29-.31q-.28-.3-.57-.58l-.32-.29c-.22-.19-.45-.37-.68-.54l-.21-.17h0a9.72,9.72,0,0,1,.25,2.17v5.51h4.43c0-.07,0-.14,0-.21C902.55,445.58,902.5,445.29,902.43,445Z"
        />
        <path
          fill="#e2e3e8"
          d="M848.83,466.63h49.54a4.37,4.37,0,0,0,4.37-4.37V450.08H898.2v7.8a4,4,0,0,1-4,4H844.91l-.45,0v.45A4.37,4.37,0,0,0,848.83,466.63Z"
        />
        <path
          fill="#11163d"
          d="M898,438.38l.21.17c.23.17.46.35.68.54l.32.29q.3.28.57.58l.29.31c.2.23.38.47.56.71l.19.25a11.2,11.2,0,0,1,.64,1l.11.23c.15.29.28.58.41.88.05.13.1.26.15.4s.18.53.25.79.08.29.11.43.12.57.16.86c0,.07,0,.14,0,.21h2V446q-.05-.44-.13-.86c0-.12,0-.24-.07-.36-.08-.37-.17-.74-.28-1.11l-.07-.2q-.14-.44-.32-.87l-.18-.42q-.14-.31-.3-.62l-.23-.43c-.13-.22-.26-.44-.4-.66s-.3-.45-.46-.66l-.31-.42-.41-.49-.28-.31c-.16-.17-.32-.34-.49-.5l0,0a13.27,13.27,0,0,0-1.28-1.08l-.18-.14c-.22-.15-.44-.3-.66-.44l-.2-.12a13.21,13.21,0,0,0-1.56-.81h0A10.54,10.54,0,0,1,898,438.38Z"
        />
        <path
          fill="#11163d"
          d="M902.73,462.26a4.37,4.37,0,0,1-4.37,4.37H848.83a4.37,4.37,0,0,1-4.37-4.37v-.45a4,4,0,0,1-2-.85v1.3a6.37,6.37,0,0,0,6.37,6.37h49.54a6.37,6.37,0,0,0,6.37-6.37V450.08h-2Z"
        />
        <path
          fill="#fafafa"
          d="M41.06,383.8c-6.65,0-8.94,5.86-7,12l0,.09a11.3,11.3,0,0,0,9.4,5H184.32V383.8H41.06Z"
        />
        <path
          fill="#131943"
          d="M186.32,403a2,2,0,0,0-2-2H43.53a11.3,11.3,0,0,1-9.4-5h0c.37,1.23.24,2.5.63,3.65a13.35,13.35,0,0,1-4.19-7l0-.1c-.09-.39-.15-.78-.2-1.18,0-.08,0-.16,0-.24a13.44,13.44,0,0,1-.08-1.43,13.3,13.3,0,0,1,13.3-13.3H184.32v2a2,2,0,1,0,0-4H43.53a15.3,15.3,0,0,0,0,30.61H184.32A2,2,0,0,0,186.32,403Z"
        />
        <path
          fill="#e2e3e7"
          d="M182.23,378.35H43.53a11.32,11.32,0,0,0-11.3,11.3c0,.35,0,.7.05,1,0,.1,0,.2,0,.3q0,.38.12.75c0,.1,0,.19.05.29.07.33.15.65.25,1l0,.06c.09.3.2.59.32.88l.12.27q.15.34.32.66l.13.25c.15.28.32.55.49.82h0l0-.09c-2-6.18.31-12,7-12H184.32V381h0v-2.63h-2.09Z"
        />
        <path
          fill="#11173e"
          d="M184.32,376.35H43.53a13.3,13.3,0,0,0-13.3,13.3,13.44,13.44,0,0,0,.08,1.43c0,.08,0,.16,0,.24.05.4.11.8.2,1.18l0,.1a13.35,13.35,0,0,0,4.19,7c-.38-1.16-.26-2.43-.63-3.65-.18-.26-.34-.54-.49-.82l-.13-.25q-.17-.33-.32-.66l-.12-.27c-.12-.29-.23-.58-.32-.88l0-.06c-.1-.32-.18-.64-.25-1,0-.09,0-.19-.05-.29q-.07-.37-.12-.75c0-.1,0-.2,0-.3,0-.34-.05-.69-.05-1a11.32,11.32,0,0,1,11.3-11.3H184.32v-2Z"
        />
        <path
          fill="#fafafa"
          d="M152.33,432.32a11.23,11.23,0,0,0,6.47-2,11.38,11.38,0,0,0,1.63-1.38l.09-.1a21.56,21.56,0,0,0-.52-2.43,1.69,1.69,0,0,1,.06-.65c.1-.32.19-.64.27-1a11.38,11.38,0,0,0,.29-4.12c-.44-3.44-2.75-6-7-6H11.53v17.68H152.33Z"
        />
        <path
          fill="#fafafa"
          d="M163.63,421c0-.15,0-.3,0-.45a20,20,0,0,1-.24,2.87A11.28,11.28,0,0,0,163.63,421Z"
        />
        <path
          fill="#e2e3e7"
          d="M160.61,420.63a11.38,11.38,0,0,1-.29,4.12c-.08.32-.16.64-.27,1a1.69,1.69,0,0,0-.06.65,21.56,21.56,0,0,1,.52,2.43,11.37,11.37,0,0,0,1.19-1.47,11.26,11.26,0,0,0,1.46-3.13c.07-.25.14-.5.19-.75a20,20,0,0,0,.24-2.87c0-.22,0-.44,0-.65a11.32,11.32,0,0,0-11.25-10.2H11.53v4.93H153.66C157.86,414.64,160.17,417.19,160.61,420.63Z"
        />
        <path
          fill="#fafafa"
          d="M171.16,463.52a9.75,9.75,0,0,0,1.4-5v-7a11.82,11.82,0,0,0-9.83-5.25H3.27v22.06H162.73A9.82,9.82,0,0,0,171.16,463.52Z"
        />
        <path
          fill="#131943"
          d="M174,466.47a13.74,13.74,0,0,0,2.55-8v-7.41a13.85,13.85,0,0,0-13.83-13.83H3.27a2,2,0,1,0,0,4v-2H162.73a11.83,11.83,0,0,1,11.83,11.83v7a11.77,11.77,0,0,0-1.43-5.62c-.18-.33-.37-.65-.57-1v7a9.87,9.87,0,0,1-9.83,9.83H3.27a2,2,0,1,0,0,4H162.73c.36,0,.72,0,1.08-.05a13.75,13.75,0,0,0,8-3.35A13.92,13.92,0,0,0,174,466.47Z"
        />
        <path
          fill="#e2e3e7"
          d="M172.56,451.5v-.42a9.84,9.84,0,0,0-9.83-9.83H3.27v5H162.73A11.82,11.82,0,0,1,172.56,451.5Z"
        />
        <path
          fill="#11173e"
          d="M172.56,451.08v.42c.21.31.39.63.57,1a11.77,11.77,0,0,1,1.43,5.62v-7a11.83,11.83,0,0,0-11.83-11.83H3.27v2H162.73A9.84,9.84,0,0,1,172.56,451.08Z"
        />
        <path
          fill="#1fb575"
          d="M162.63,432.3a14.61,14.61,0,0,0,2.55-3l0,0,.05-.09a15.18,15.18,0,0,0,2.27-6.37,15.33,15.33,0,0,0-15.19-17.09H11.53a2,2,0,0,0,0,4H152.33a11.32,11.32,0,0,1,11.25,10.2c0,.22,0,.44,0,.65s0,.3,0,.45a11.28,11.28,0,0,1-.27,2.42c-.06.25-.12.5-.19.75a11.26,11.26,0,0,1-1.46,3.13,11.37,11.37,0,0,1-1.19,1.47l-.09.1a11.38,11.38,0,0,1-1.63,1.38,11.23,11.23,0,0,1-6.47,2H11.53a2,2,0,0,0,0,4H152.33a15.22,15.22,0,0,0,10.2-3.93l0,0Z"
        />
      </svg>
    </div>
  )
}
;``
